import styled, { css } from 'styled-components'

export const PromotionRulesGroup = styled.section`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
    width: 100%;
  `}
`
